import axios from 'axios';
import { API_URL } from 'config.js';
import { store } from 'store.js';
import { caricamento, aggiornaSchede, caricamentoDettagli, aggiornaDettagliScheda } from 'features/99/schedeTecniche/schedeSlice';

const API_SCHEDE_URL = `${API_URL}/99/schedeTecniche/`;
const API_SCHEDE_DETTAGLI_URL = `${API_URL}/99/schedeTecniche/dettagli/`;

export const richiediDati = async () => {
  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  const res = await axios.post(API_SCHEDE_URL, { utente, pin });

  const {
    data: {
      successo,
      errore,
      dati = {
        schede: [],
      },
    },
  } = res;

  const { schede } = dati;

  if (!successo) {
    store.dispatch(caricamento(false));
    return alert(errore);
  }

  if (successo && schede.length) {
    store.dispatch(aggiornaSchede(schede));
    store.dispatch(caricamento(false));
  }

  store.dispatch(caricamento(false));
  return true;
};

export const richiediDettagli = async () => {
  store.dispatch(caricamentoDettagli(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
    schede99: { currentScheda },
  } = store.getState();

  const res = await axios.post(API_SCHEDE_DETTAGLI_URL, { utente, pin, idScheda: currentScheda?.IdScheda });

  const {
    data: {
      successo,
      errore,
      dati: { dettagli = [] },
    },
  } = res;

  if (!successo) {
    store.dispatch(caricamentoDettagli(false));
    return alert(errore);
  }

  if (successo && dettagli.length) {
    store.dispatch(aggiornaDettagliScheda(dettagli));
    store.dispatch(caricamentoDettagli(false));
  }

  store.dispatch(caricamentoDettagli(false));
  return true;
};
